import { getCurrentUserRole } from "modules/utilities/utility";
import api from "../../../../api";
import moment from "moment";
import { day } from "is_js";
import secureLocalStorage from "react-secure-storage";
const repId = secureLocalStorage.getItem("id");

export function assignedFetchData(sd, ed, PageNumber, query) {
  const apiEndpoint = ["medrep_ext"].includes(getCurrentUserRole())
    ? `v3/get-assigned-tickets/${repId}/${sd}/${ed}?pageNumber=${PageNumber}${query && query.length ? `&${query}` : ``}`
    : `v2/get-assigned-tickets/${repId}/${sd}/${ed}?pageNumber=${PageNumber}${query && query.length ? `&${query}` : ``}`;
    return api.get(apiEndpoint);
}

export const assignedTicketsStatsData = (sd, ed, query) => {
  return api.get(`v3/get-assigned-tickets-stats/${repId}/${sd}/${ed}${query && query.length ? `?${query}` : ``}`);
}
export function fetchDataDownload(sd, ed) {
  return api.get(`/download-assigned-tickets/${repId}/${sd}/${ed}`);
}

export const downloadAssignedTickets = (query, payload) => {
  return api.post(`download-assigned-tickets/${repId}${query && query.length ? `?${query}` : ``}`,payload);
}
export function updateAssignedTickets(id, payload) {
  return api.put(`update-ticket/${id}`, payload);
}

export function uploadImageTicket(data, ticketId, documentType) {
  const url = documentType
    ? `ticket/${ticketId}/upload?documentType=${documentType}`
    : `ticket/${ticketId}/upload`;
  return api.put(url, data);
}

export function getAssignee(data) {
  return api.get(`get-assignee-setting?settingKey=${data}`);
}

export function getPreviousAssignee(ticketId) {
  return api.get(`get-acl-members-info/${ticketId}`);
}

export function shopifyReturn(payload) {
  return api.post("shopify-return-refund", payload);
}

export function setEscalationPrescritiption(id, payload) {
  return api.post(`escalation-prescription/${id}`, payload);
}

export function saveMedicalPrescription(caseId, payload) {
  return api.post(`medical-prescription/${caseId}`, payload);
}

export function fetchInstantRefund(payload) {
	return api.post(`get-instant-refund`, payload);
}

export function fetchMedicalEscalationTickets(page, status='', subCatKey='',selectedUser='', startDate, endDate) {
  return api.get(`medical-esaclation-tickets?page=${page}&status=${status}&subCatKey=${subCatKey}&selectedUser=${selectedUser}&startDate=${moment(startDate).startOf('day').toISOString()}&endDate=${moment(endDate).endOf('day').toISOString()}`);
}

export function fetchDownloadMedicalEscalationPrescription(startDate, endDate) {
  return api.get(`download-medical-esaclation-prescription?startDate=${moment(startDate).startOf('day').toISOString()}&endDate=${moment(endDate).endOf('day').toISOString()}`);
}

export function fetchDownloadMedicalEscalationTickets(status='', subCatKey='',selectedUser='', startDate, endDate ) {
  return api.get(`download-medical-esaclation-tickets?status=${status}&subCatKey=${subCatKey}&selectedUser=${selectedUser}&startDate=${moment(startDate).startOf('day').toISOString()}&endDate=${moment(endDate).endOf('day').toISOString()}`);
}

export function orderCancellationShopify(payload) {
  return api.post('order-cancellation-shopify', payload);
}

export function makeShopifyPartialReturnRefund(payload) {
  return api.post('shopify-partial-return-refund', payload);
}

export function fetchAvailableActivityEvents(ticketId) {
  return api.get(`available-activity-events/${ticketId}`);
}